/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Jobticketexportiertam3Inputs */



/**

* @param {_Field_Jobticketexportiertam3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_jobticketexportiertam3 = /** @type {((inputs?: _Field_Jobticketexportiertam3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Jobticketexportiertam3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Jobticket Exportiert Am")
});
export { _field_jobticketexportiertam3 as "_field_jobTicketExportiertAm" }